import { useCallback, useState } from "react";

import { Column } from "../../system-design/Table/DSBaseTable/components/DSBaseTable";
import { debounce } from "lodash";
import useCollectionsReviewInfiniteQuery from "./useCollectionsReviewInfiniteQuery";
import { PopulatedDraftCollection } from "../../../api/collection";

const useCollectionsReviewedList = () => {
  const [selectedCollection, setSelectedCollection] = useState<
    PopulatedDraftCollection | undefined
  >(undefined);
  const [textSearch, setTextSearch] = useState<string>("");
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);

  const columns: Column<PopulatedDraftCollection>[] = [
    { field: "name", label: "Name" },
    { field: "coverUrl", label: "Cover" },
    { field: "creatorId", label: "Creator" },
    { field: "reviewStatus", label: "Status" },
    { field: "createdAt", label: "Created At" },
  ];

  const handleSelectRow = useCallback(
    (collection: PopulatedDraftCollection) => {
      setSelectedCollection(collection);
      setIsModalOpen(true);
    },
    [],
  );

  const handleTextSearch = useCallback(
    debounce((text) => setTextSearch(text), 500),
    [],
  );

  const handleCloseModal = useCallback(() => {
    setIsModalOpen(false);
    setSelectedCollection(undefined);
  }, []);

  const { data, fetchNextPage, ...rest } =
    useCollectionsReviewInfiniteQuery(textSearch);

  return {
    data,
    fetchNextPage,
    ...rest,
    columns,
    selectedCollection,
    handleSelectRow,
    textSearch,
    handleTextSearch,
    isModalOpen,
    handleCloseModal,
  };
};

export default useCollectionsReviewedList;
